import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "../apiService";

export const useCreateExternalStorageSimulation = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const response = await axiosApi.post("/external-storage", data);
    return response.data;
  }, opt);

export const useUpdateExternalStorageSimulation = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (data: any) => {
    const response = await axiosApi.put(`/external-storage/${data.externalStorageId}`, data);
    return response.data;
  }, opt);

export const useGetExternalStorageSimulationById = (id: string) =>
  useQuery<any, ApiServiceErr>(
    ["getExternalStorageSimulationById", id],
    async () => {
      const response = await axiosApi.get(`/external-storage/${id}`);
      return response.data;
    },
    {
      enabled: !!id,
      refetchOnWindowFocus: false
    }
  );

export const useDeleteExternalStorageSimulation = (opt?: any) =>
  useMutation<any, ApiServiceErr, any>(async (externalStorageId: string) => {
    const response = await axiosApi.delete(`/external-storage/${externalStorageId}`);
    return response.data;
  }, opt);
